import Ajax from '../../../../util/ajax';
export function zigbeOnWithRecallGlobalScene(nid, eid) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch, true);
        const url = '/zigbee/' + nid + '/ep/' + eid + '/cluster/6/command/on-with-recall-global-scene';
        ajax.post(url);
    };
}
